import { Controller } from "stimulus";
import { v4 } from "uuid";
import checkXhr from "../../functions/checkXhr.js";
import dispatchCustomEvent from "../../functions/dispatchCustomEvent.js";
import displayFlashMessage from "../../functions/displayFlashMessage.js";
import parseJson from "../../functions/parseJson.js";
import {
  addAjaxPending,
  removeAjaxPending,
} from "../../functions/ajaxPending.js";

export default class extends Controller {
  static targets = ["changeRequestId"];

  onSuccess(event) {
    const response = this._parse(event.detail);

    if (!response) {
      return;
    }

    this.element.reset();

    if (response.redirectTo) {
      const originalUrl = new URL(window.location.href);
      const redirectUrl = new URL(response.redirectTo, window.location.origin);

      window.location.replace(redirectUrl);

      if (originalUrl.pathname !== redirectUrl.pathname) {
        return;
      }
    }

    response.messages.forEach(function (message) {
      displayFlashMessage(message);
    });

    this.successEvents.forEach(function (eventName) {
      dispatchCustomEvent(document, eventName);
    });
  }

  onError(event) {
    const response = this._parse(event.detail);

    if (!response) {
      return;
    }

    if (response.redirectTo) {
      window.location.replace(response.redirectTo);
    }

    response.messages.forEach(function (message) {
      displayFlashMessage(message);
    });
  }

  _parse(xhr) {
    const problem = checkXhr(xhr, { method: this.element.method, url: this.element.action, expectsJson: true });

    return parseJson(xhr.response, problem);
  }

  addPending() {
    addAjaxPending(this.element);
  }

  removePending() {
    removeAjaxPending(this.element);
  }

  // The server rejects a reused change request id, so a form that stays on the page needs a
  // new one after every submit.
  refreshChangeRequestId() {
    if (!this.hasChangeRequestIdTarget) return;

    this.changeRequestIdTarget.value = v4();
  }

  showOverlay() {
    const event = new CustomEvent("overlay:show", { bubbles: true });
    this.element.dispatchEvent(event);
  }

  hideOverlay() {
    const event = new CustomEvent("overlay:hide", { bubbles: true });
    this.element.dispatchEvent(event);
  }

  get successEvents() {
    if (!this.element.dataset.ajaxRequestSuccessEvents) {
      return [];
    }

    return this.element.dataset.ajaxRequestSuccessEvents.split(" ");
  }
}
